export default class AttendancesController {
  /** @ngInject */
  constructor(
    $log, $state,
    invalidAttendances
  ) {
    this.$log = $log;
    this.$state = $state;
    this.invalidAttendances = invalidAttendances || [];

    this.currentStateName = this.$state.current.name;
  }
}
